<template>
    <div v-if="Object.keys(criterio).length > 0" class="df_container-fluid fluid-width fluid-max detallecriterio">

        <div class="vc_row wpb_row vc_row-fluid">
            <div class="wpb_column vc_column_container vc_col-sm-12"><div class="vc_column-inner "><div class="wpb_wrapper">

                <h1>Ficha detalle de Criterio:</h1>

            </div></div></div>
        </div>


        <div class="vc_row wpb_row vc_row-fluid">
            <div class="wpb_column vc_column_container vc_col-sm-4"><div class="vc_column-inner "><div class="wpb_wrapper">
                <div class="cajafiltro">
                    <h4>Órgano: <strong>{{ criterio.organo==null ? '' : criterio.organo.nombre }}</strong></h4>
                    <h4>Localización: <strong>{{ criterio.localizacion==null ? '' : criterio.localizacion.nombre }}</strong></h4>
                    <h4>Fase: <strong>{{ criterio.fase|firstToUpperCase }}</strong></h4>
                    <h4>Fecha: <strong>{{ criterio.fecha_adopcion==null ? '' : criterio.fecha_adopcion }}</strong></h4>
                    <h4>Jurisdicción: <strong>{{ criterio.jurisdiccion==null ? '' : criterio.jurisdiccion.nombre }}</strong></h4>
                    <h4>{{ criterio.materia==null ? '' : criterio.materia.nombre+'.' }} {{ criterio.submateria==null ? '' : criterio.submateria.nombre+'.' }} {{ criterio.subsubmateria==null ? '' : criterio.subsubmateria.nombre+'.' }}</h4>
                </div>
                <ul class="list-inline">
                    <li class="list-inline-item"><button type="button" class="btn btn-primary" @click="clickVolver">Volver</button></li>
                    <li class="list-inline-item float-right"><a :href="getFacebookUrl(criterio.id)" class="social" target="_blank"><i class="fa fa-facebook"></i></a></li>
                    <li class="list-inline-item float-right">Compartir en: <a :href="getTwitterkUrl(criterio.id)" class="social" target="_blank"><i class="fa fa-twitter"></i></a></li>
                </ul>

            </div></div></div>
            <div class="wpb_column vc_column_container vc_col-sm-8"><div class="vc_column-inner "><div class="wpb_wrapper">
                <h3>Criterio: </h3>
                <p>{{ criterio.descripcion==null ? '' : criterio.descripcion }}</p>

                <h4><strong>Fuentes:</strong></h4>

                <div class="table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th scope="col">Resolución</th>
                            <th scope="col">ECLI</th>
                            <th scope="col">Recurso</th>
                            <th scope="col">Fecha resolución</th>
                            <th scope="col">Enlace</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="resolucion in resoluciones">
                            <th scope="row">{{ formatSentencia(resolucion.tipo) }}</th>
                            <td>{{ resolucion.ecli==null ? '' : resolucion.ecli }}</td>
                            <td>{{ resolucion.recurso==null ? '' : resolucion.recurso }}</td>
                            <td>{{ resolucion.fecha_resolucion==null ? '' : resolucion.fecha_resolucion }}</td>
                            <td><a style="background-color:#000000; color:#ffffff;" class="vc_general vc_btn3 vc_btn3-size-sm vc_btn3-shape-rounded vc_btn3-style-custom vc_btn3-icon-left" href="#" @click.prevent="clickCendojUrl(resolucion.cendoj_url)" target="_blank"><i class="vc_btn3-icon fa fa-external-link"></i> Consultar</a></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <h5>Acuerdo no jurisdiccional</h5>
                <div class="table-responsive">
                    <table class="table mt-2">
                        <thead>
                        <tr>
                            <th scope="col">Acuerdo</th>
                            <th scope="col">Número</th>
                            <th scope="col">Fecha de adopción</th>
                            <th scope="col">Adjunto</th>
                            <th scope="col">Enlace</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="acuerdo in acuerdos">
                            <td>{{ acuerdo.acuerdo|firstToUpperCase }}</td>
                            <td>{{ acuerdo.numero==null ? '' : acuerdo.numero }}</td>
                            <td>{{ acuerdo.fecha_adopcion==null ? '' : acuerdo.fecha_adopcion }}</td>
                            <td><a v-if="acuerdo.adjunto!=null" style="background-color:#000000; color:#ffffff;" class="vc_general vc_btn3 vc_btn3-size-sm vc_btn3-shape-rounded vc_btn3-style-custom vc_btn3-icon-left" :href="urlAdjunto(acuerdo.adjunto)" target="_blank"><i class="vc_btn3-icon fa fa-external-link"> Ir</i></a></td>
                            <td><a style="background-color:#000000; color:#ffffff;" class="vc_general vc_btn3 vc_btn3-size-sm vc_btn3-shape-rounded vc_btn3-style-custom vc_btn3-icon-left" href="#" @click.prevent="clickCendojUrl(acuerdo.cendoj_url)" target="_blank"><i class="vc_btn3-icon fa fa-external-link"></i> Consultar</a></td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div></div></div>
        </div>

        <modal name="aviso-modal" :clickToClose="false" :adaptive="true" height="auto" @closed="goCendojUrl" @before-open="modalBeforeOpen" @before-close="modalBeforeClose">
            <div class="df_modal-content">
                <div class="df_modal-header" style="text-align: center">
                    <h3 class="df_modal-title" style="">Aviso</h3>
                </div>
                <div class="df_modal-body ult-html" style="">
                    <p>Va a abandonar FMRF para entrar en CENDOJ en {{contador}} segundos</p>
                </div>
            </div>
<!--            <div slot="top-right">-->
<!--                <a href="#" class="df-overlay-close" @click="$modal.hide('aviso-modal')">Close</a>-->
<!--            </div>-->
        </modal>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import store from "../store.js"
    import axios from 'axios';

    const SERVER='https://admin.fundacionmarianoruizfunes.com';
    // const SERVER='http://fmrf2.local';
    const WS_URL=SERVER+'/api/ws/criterio';
    let headers = {
        'Content-Type': 'application/json'
    };

    export default {
        name: "Detalle",
        data() {
            return {
                criterio: {},
                url: null,
                timer: null,
                contador: 3,
            }
        },
        filters: {
            substring: function (texto, limite) {
                if (texto == null)
                    texto = '';
                else if (texto.length > limite)
                    texto = texto.substring(0, limite) + '...';

                return texto;
            },
            isNotNull: function (value, campo) {
                if (value != null) {
                    return value[campo];
                } else
                    return '';
            },
            firstToUpperCase: function (string) {
                if(string==null)
                    return '';
                else
                    return string.charAt(0).toUpperCase() + string.slice(1);
            }
        },
        watch: {
            id: function () {
                this.leerCriterio();
            }
        },
        computed:{
            resoluciones: function(){
                let arrayTemp=[];
                if(this.criterio.apoyos.length>0){
                    for(let i=0;i<this.criterio.apoyos.length;i++){
                        if(this.criterio.apoyos[i].tipo!='acuerdo')
                            arrayTemp.push(this.criterio.apoyos[i]);
                    }
                }
                return arrayTemp;
            },
            acuerdos: function(){
                let arrayTemp=[];
                if(this.criterio.apoyos.length>0){
                    for(let i=0;i<this.criterio.apoyos.length;i++){
                        if(this.criterio.apoyos[i].tipo=='acuerdo')
                            arrayTemp.push(this.criterio.apoyos[i]);
                    }
                }
                return arrayTemp;
            },
            ...mapState(['id'])
        },
        methods: {
            leerCriterio(){
                axios
                    .post(WS_URL, {
                        "operacion": "getCriterio",
                        "id": this.id
                    }, {"headers": headers})
                    .then(response => {
                        if(response.data=="{}")
                            this.criterio = {};
                        else
                            this.criterio = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            formatSentencia(sentencia){
                switch (sentencia) {
                    case 'auto':
                        return 'Auto';
                        break;
                    case 'sentencia1':
                        return 'Sentencia';
                        break;
                    case 'sentencia2':
                        return 'Sentencia sección ';
                        break;
                    case 'sentencia3':
                        return 'Sentencia pleno';
                        break;
                }
            },
            clickVolver(){
                // this.$router.push('/listado');
                this.$router.go(-1);
            },
            getFacebookUrl(criterio){
                let url='https://www.facebook.com/sharer.php?u=';
                //url+=encodeURIComponent(window.location.origin+this.$router.resolve({ name: 'criterio', params: { id: criterio }}).href);
                url+=encodeURIComponent(window.location.href);
                return url;
            },
            getTwitterkUrl(criterio){
                let url='https://twitter.com/share?url=';
                //url+=encodeURIComponent(window.location.origin+this.$router.resolve({ name: 'criterio', params: { id: criterio }}).href);
                url+=encodeURIComponent(window.location.href);
                return url;
            },
            clickCendojUrl(url){
                if(url!=null) {
                    this.url=url;
                    this.$modal.show('aviso-modal');
                }
            },
            goCendojUrl(){
                if(this.url!=null) {
                    window.open(this.url, '_blank');
                    //this.$router.go(-1);
                }
            },
            modalBeforeOpen(){
                this.timer=setInterval(() => {
                    //this.$modal.hide('aviso-modal');
                    if(this.contador==1)
                        this.$modal.hide('aviso-modal');
                    else
                       this.contador--;
                }, 1000);
            },
            modalBeforeClose(){
                this.contador=3;
                clearInterval(this.timer);
            },
            urlAdjunto(adjunto) {
                return SERVER+"/storage/"+this.id+"/"+adjunto;
            },
        },
        mounted() {
            this.leerCriterio();
        },
        beforeRouteEnter (to, from, next) {
            // store.state.buscador.id=to.params.id;
            store.state.id=to.params.id;
            next();
        },
        beforeRouteUpdate (to, from, next) {
            // store.state.buscador.id=to.params.id;
            store.state.id=to.params.id;
            next();
        }
    }
</script>

<style>

</style>